import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { SubscriptionPlanCatalogEntry } from '../types/subscriptionPlanCatalogEntry'

export const subscriptionPlansCatalog: Partial<Record<SubscriptionPlan, SubscriptionPlanCatalogEntry>> = {
  [SubscriptionPlan.Archive]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: true,
      upgradableTo: [],
    },
  },
  [SubscriptionPlan.Archive5Year]: {
    displayAs: SubscriptionPlan.Archive,
  },
  [SubscriptionPlan.Basic]: {
    displayAs: SubscriptionPlan.Free,
  },
  [SubscriptionPlan.BasicPaid]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [SubscriptionPlan.Plus, SubscriptionPlan.Complete],
    },
    content: {
      comparison: 'subscription.plan.basic_paid.comparison_to_other_plans',
      cta: 'subscription.plan.basic_paid.cta',
      description: 'subscription.plan.basic_paid.description',
      features: [
        'subscription.plan.all_features.ad_free_invoicing',
        'subscription.plan.all_features.full_bookkeeping_support',
        'subscription.plan.all_features.auditor_access',
      ],
      featuresHeader: 'subscription.plan.basic_paid.features.header',
      highlight: 'subscription.plan.basic_paid.highlight',
      name: 'organization_subscription.basic_paid',
    },
    marketOverrides: {
      de: { displayAs: SubscriptionPlan.Start },
      fr: { displayAs: SubscriptionPlan.Start },
      nl: { displayAs: SubscriptionPlan.Start },
    },
  },
  [SubscriptionPlan.Business]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [],
    },
    content: {
      comparison: 'subscription.plan.nl.business.comparison_to_other_plans',
      cta: 'subscription.plan.nl.business.cta',
      description: 'subscription.plan.nl.business.description',
      features: [],
      featuresHeader: 'subscription.plan.nl.business.features.header',
      name: 'organization_subscription.nl.business',
    },
    marketOverrides: {
      de: {
        content: {
          comparison: 'subscription.plan.de.business.comparison_to_other_plans',
          cta: 'subscription.plan.de.business.cta',
          description: 'subscription.plan.de.business.description',
          featuresHeader: 'subscription.plan.de.business.features.header',
          name: 'organization_subscription.de.business',
        },
      },
      fr: {
        content: {
          comparison: 'subscription.plan.fr.business.comparison_to_other_plans',
          cta: 'subscription.plan.fr.business.cta',
          description: 'subscription.plan.fr.business.description',
          featuresHeader: 'subscription.plan.fr.business.features.header',
          name: 'organization_subscription.fr.business',
        },
      },
    },
  },
  [SubscriptionPlan.Complete]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: true,
      noPeriodSelection: true,
      upgradableTo: [],
    },
    content: {
      comparison: 'subscription.plan.complete.comparison_to_other_plans',
      cta: 'subscription.plan.complete.cta',
      description: 'subscription.plan.complete.description',
      features: [
        'subscription.plan.all_features.accounting_check',
        'subscription.plan.all_features.annual_accounts',
        'subscription.plan.all_features.skip_the_queue',
      ],
      featuresHeader: 'subscription.plan.complete.features.header',
      highlight: 'subscription.plan.complete.highlight',
      name: 'organization_subscription.complete',
    },
  },
  [SubscriptionPlan.CpaFree]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [],
    },
    content: { name: 'organization_subscription.cpa_free' },
  },
  [SubscriptionPlan.CpaPlus]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [],
    },
    content: { name: 'organization_subscription.cpa_plus' },
  },
  [SubscriptionPlan.CpaStart]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [],
    },
    content: { name: 'organization_subscription.cpa_start' },
  },
  [SubscriptionPlan.Free]: {
    behavior: {
      hasLimits: true,
      isFree: true,
      noCoupons: false,
      noPeriodSelection: true,
      upgradableTo: [SubscriptionPlan.BasicPaid, SubscriptionPlan.Plus, SubscriptionPlan.Complete],
    },
    content: {
      cta: 'subscription.plan.free.cta',
      description: 'subscription.plan.dk.free.description',
      featuresHeader: 'subscription.plan.dk.free.features.header',
      features: [
        'subscription.plan.all_features.accounting_system',
        'subscription.plan.all_features.invoicing_simple',
        'subscription.plan.all_features.vat_reporting',
        'subscription.plan.all_features.technical_email_and_chat',
        'subscription.plan.all_features.receipt_upload',
      ],
      name: 'organization_subscription.free',
    },
    marketOverrides: {
      de: {
        behavior: { upgradableTo: [SubscriptionPlan.Start, SubscriptionPlan.Plus] },
        content: {
          description: 'subscription.plan.free.description',
          featuresHeader: 'subscription.plan.free.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts_and_purchases',
            'subscription.plan.all_features.unlimited_invoicing',
            'subscription.plan.all_features.e_invoicing',
            'subscription.plan.all_features.track_income_and_expenses',
            'subscription.plan.all_features.one_bank_connection',
          ],
        },
      },
      fr: {
        behavior: { upgradableTo: [SubscriptionPlan.Start, SubscriptionPlan.Plus] },
        content: {
          description: 'subscription.plan.free.description',
          featuresHeader: 'subscription.plan.free.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts_and_purchases',
            'subscription.plan.all_features.unlimited_invoicing',
            'subscription.plan.all_features.advanced_e_invoicing',
            'subscription.plan.all_features.track_income_and_expenses',
            'subscription.plan.all_features.one_bank_connection',
          ],
        },
      },
      nl: {
        behavior: { upgradableTo: [SubscriptionPlan.Start, SubscriptionPlan.Plus] },
        content: {
          description: 'subscription.plan.free.description',
          featuresHeader: 'subscription.plan.free.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts_and_purchases',
            'subscription.plan.all_features.unlimited_invoicing',
            'subscription.plan.all_features.track_income_and_expenses',
            'subscription.plan.all_features.one_bank_connection',
          ],
        },
      },
    },
  },
  [SubscriptionPlan.Plus]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [SubscriptionPlan.Complete],
    },
    content: {
      comparison: 'subscription.plan.dk.plus.comparison_to_other_plans',
      cta: 'subscription.plan.plus.cta',
      description: 'subscription.plan.dk.plus.description',
      features: [
        'subscription.plan.all_features.advanced_ai_features',
        'subscription.plan.all_features.unlimited_integrations',
        'subscription.plan.all_features.full_accounting_support',
        'subscription.plan.all_features.payroll_system',
      ],
      featuresHeader: 'subscription.plan.dk.plus.features.header',
      highlight: 'subscription.plan.plus.highlight',
      name: 'organization_subscription.plus',
    },
    marketOverrides: {
      de: {
        behavior: { upgradableTo: [] },
        content: {
          comparison: '',
          description: 'subscription.plan.plus.description',
          features: [
            'subscription.plan.all_features.unlimited_contacts_and_purchases',
            'subscription.plan.all_features.scout',
            'subscription.plan.all_features.automatic_payment_reminder',
            'subscription.plan.all_features.recurring_invoices',
          ],
          featuresHeader: 'subscription.plan.plus.features.header',
        },
      },
      fr: {
        behavior: { upgradableTo: [] },
        content: {
          comparison: '',
          description: 'subscription.plan.plus.description',
          features: [
            'subscription.plan.all_features.unlimited_contacts_and_purchases',
            'subscription.plan.all_features.scout',
            'subscription.plan.all_features.automatic_payment_reminder',
            'subscription.plan.all_features.recurring_invoices',
          ],
          featuresHeader: 'subscription.plan.plus.features.header',
        },
      },
      nl: {
        behavior: { upgradableTo: [] },
        content: {
          comparison: '',
          description: 'subscription.plan.plus.description',
          features: [
            'subscription.plan.all_features.unlimited_contacts_and_purchases',
            'subscription.plan.all_features.scout',
            'subscription.plan.all_features.automatic_payment_reminder',
            'subscription.plan.all_features.recurring_invoices',
            'subscription.plan.all_features.payroll',
            'subscription.plan.all_features.phone_support',
          ],
          featuresHeader: 'subscription.plan.plus.features.header',
        },
      },
    },
  },
  [SubscriptionPlan.PlusTrial]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [
        SubscriptionPlan.Basic,
        SubscriptionPlan.BasicPaid,
        SubscriptionPlan.Plus,
        SubscriptionPlan.Complete,
      ],
    },
    content: { name: 'organization_subscription.plus', planName: 'organization_subscription.plus_trial' },
    marketOverrides: {
      de: { behavior: { upgradableTo: [SubscriptionPlan.Free, SubscriptionPlan.Start, SubscriptionPlan.Plus] } },
      fr: { behavior: { upgradableTo: [SubscriptionPlan.Free, SubscriptionPlan.Start, SubscriptionPlan.Plus] } },
      nl: { behavior: { upgradableTo: [SubscriptionPlan.Free, SubscriptionPlan.Start, SubscriptionPlan.Plus] } },
    },
  },
  [SubscriptionPlan.Premium]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [SubscriptionPlan.Complete],
    },
  },
  [SubscriptionPlan.PremiumTrial]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [
        SubscriptionPlan.Basic,
        SubscriptionPlan.BasicPaid,
        SubscriptionPlan.Plus,
        SubscriptionPlan.Complete,
      ],
    },
    content: { name: 'organization_subscription.premium', planName: 'organization_subscription.premium_trial' },
    marketOverrides: {
      de: { displayAs: SubscriptionPlan.PlusTrial },
      fr: { displayAs: SubscriptionPlan.PlusTrial },
      nl: { displayAs: SubscriptionPlan.PlusTrial },
    },
  },
  [SubscriptionPlan.Pro]: {
    behavior: {
      hasLimits: false,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [SubscriptionPlan.Plus, SubscriptionPlan.Complete],
    },
  },
  [SubscriptionPlan.Start]: {
    behavior: {
      hasLimits: true,
      isFree: false,
      noCoupons: false,
      noPeriodSelection: false,
      upgradableTo: [SubscriptionPlan.Plus],
    },
    content: {
      comparison: 'subscription.plan.dk.start.comparison_to_other_plans',
      cta: 'subscription.plan.start.cta',
      description: 'subscription.plan.dk.start.description',
      features: [],
      featuresHeader: 'subscription.plan.dk.start.features.header',
      name: 'organization_subscription.start',
    },
    marketOverrides: {
      de: {
        content: {
          comparison: '',
          description: 'subscription.plan.start.description',
          featuresHeader: 'subscription.plan.start.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts',
            'subscription.plan.all_features.limited_purchases',
            'subscription.plan.all_features.convert_quote_to_invoice',
            'subscription.plan.all_features.customized_quotes_and_invoices',
            'subscription.plan.all_features.advanced_invoicing',
            'subscription.plan.all_features.payment_reminder',
            'subscription.plan.all_features.phone_support',
          ],
          highlight: 'subscription.plan.start.highlight',
        },
      },
      fr: {
        content: {
          comparison: '',
          description: 'subscription.plan.start.description',
          featuresHeader: 'subscription.plan.start.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts',
            'subscription.plan.all_features.limited_purchases',
            'subscription.plan.all_features.convert_quote_to_invoice',
            'subscription.plan.all_features.customized_quotes_and_invoices',
            'subscription.plan.all_features.advanced_invoicing',
            'subscription.plan.all_features.payment_reminder',
            'subscription.plan.all_features.phone_support',
          ],
          highlight: 'subscription.plan.start.highlight',
        },
      },
      nl: {
        content: {
          comparison: '',
          description: 'subscription.plan.start.description',
          featuresHeader: 'subscription.plan.start.features.header',
          features: [
            'subscription.plan.all_features.limited_contacts',
            'subscription.plan.all_features.limited_purchases',
            'subscription.plan.all_features.convert_quote_to_invoice',
            'subscription.plan.all_features.customized_quotes_and_invoices',
            'subscription.plan.all_features.advanced_invoicing',
            'subscription.plan.all_features.payment_reminder',
            'subscription.plan.all_features.vat_calculation',
          ],
          highlight: 'subscription.plan.start.highlight',
        },
      },
    },
  },
}
